import maskit from "vue-the-mask/src/maskit";
import tokens from "vue-the-mask/src/tokens";

export default class {
    static it(value, mask) {
        return maskit(value, mask, true, tokens)
    }
}
